import React, { useContext } from 'react'
import { DataContext } from './DataContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

const DetailTabs = () => {
    const { visibleTab, setVisibleTab } = useContext(DataContext)
    const { tabClass } = useContext(PanelStyleContext)
    return (
        <div className={`tabs is-small is-boxed is-fullwidth ${tabClass}`}>
            <ul>
                <li
                    className={visibleTab === 'well' ? 'is-active' : ''}
                    onClick={() => setVisibleTab('well')}
                >
                    <div>
                        <span>Well Details</span>
                    </div>
                </li>
                <li
                    className={visibleTab === 'screens' ? 'is-active' : ''}
                    onClick={() => setVisibleTab('screens')}
                >
                    <div>
                        <span>Well Screens</span>
                    </div>
                </li>
                <li
                    className={visibleTab === 'samples' ? 'is-active' : ''}
                    onClick={() => setVisibleTab('samples')}
                >
                    <div>
                        <span>Sample Results</span>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default DetailTabs
